import styles from '../../pages/home_page/Template.module.scss';

export const Macbook = () => {
    return (
        <svg width="1008" viewBox="0 0 1008 568" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.macbook}>
            <path d="M99 28C99 13.0883 111.088 1 126 1H886C900.912 1 913 13.0883 913 28V550C913 551.657 911.657 553 910 553H102C100.343 553 99 551.657 99 550V28Z" fill="#E2E8F0" stroke="#CBD5E0" stroke-width="2"/>
            <path d="M103 27C103 14.8497 112.85 5 125 5H887C899.15 5 909 14.8497 909 27V533H103V27Z" fill="#E2E8F0"/>
            <rect x="124" y="33" width="761" height="478" fill="white"/>
            <path d="M0 552C0 550.895 0.895431 550 2 550H1006C1007.1 550 1008 550.895 1008 552V556H0V552Z" fill="#E2E8F0"/>
            <path d="M0 552C0 550.895 0.895431 550 2 550H1006C1007.1 550 1008 550.895 1008 552V556H0V552Z" fill="url(#paint0_linear_50_306)"/>
            <path d="M0 556H1008L987.646 560.105C961.613 565.355 935.123 568 908.566 568H97.9089C68.724 568 39.6267 564.806 11.1367 558.475L0 556Z" fill="#E2E8F0"/>
            <path d="M0 556H1008L987.646 560.105C961.613 565.355 935.123 568 908.566 568H97.9089C68.724 568 39.6267 564.806 11.1367 558.475L0 556Z" fill="url(#paint1_linear_50_306)"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M430.033 550C430.547 553.351 428.052 556 436 556H573C580.948 556 578.453 553.351 578.967 550H430.033Z" fill="#E2E8F0"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M430.033 550C430.547 553.351 428.052 556 436 556H573C580.948 556 578.453 553.351 578.967 550H430.033Z" fill="url(#paint2_linear_50_306)"/>
            <defs>
            <linearGradient id="paint0_linear_50_306" x1="-1.94452e-10" y1="553" x2="1008" y2="553" gradientUnits="userSpaceOnUse">
            <stop stop-color="#B7C2D0"/>
            <stop offset="0.0295345" stop-color="#CAD4DB"/>
            <stop offset="0.0625" stop-color="#BECCDE"/>
            <stop offset="0.133609" stop-color="#B7C2D0" stop-opacity="0.7"/>
            <stop offset="0.865967" stop-color="#B7C2D0" stop-opacity="0.7"/>
            <stop offset="0.941937" stop-color="#BECCDE"/>
            <stop offset="0.971275" stop-color="#CAD4DB"/>
            <stop offset="0.996436" stop-color="#B7C2D0"/>
            </linearGradient>
            <linearGradient id="paint1_linear_50_306" x1="504" y1="556" x2="504" y2="568" gradientUnits="userSpaceOnUse">
            <stop stop-color="#D1DBE9"/>
            <stop offset="1" stop-color="#AAB5C6"/>
            </linearGradient>
            <linearGradient id="paint2_linear_50_306" x1="444.724" y1="553.643" x2="566.952" y2="553.643" gradientUnits="userSpaceOnUse">
            <stop stop-color="#CFD9E7"/>
            <stop offset="0.317518" stop-color="#CFD9E7" stop-opacity="0"/>
            <stop offset="0.660584" stop-color="#CFD9E7" stop-opacity="0"/>
            <stop offset="1" stop-color="#CFD9E7"/>
            </linearGradient>
            </defs>
        </svg> 
    )
}